// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"f2caa866","55":"38b08fda","717":"788794fb"}[chunkId] + ".chunk.css";
};